import { useTheme } from '@mui/material/styles';

import { useMatchQuery } from './useMatchQuery';

/**
 * Пользовательский хук, который определяет, является ли текущий размер экрана размером десктопа.
 *
 * @returns Возвращает true, если размер экрана 'md' или больше, иначе false.
 */
export const useIsDesktop = () => {
  const theme = useTheme();

  return useMatchQuery(theme.breakpoints.up('md'));
};
